'use client';

import React from 'react';
import { useToastStore } from '../../store/useToastStore';
import Toast from './Toast';

const GlobalToast: React.FC = () => {
  const { toast, hideToast } = useToastStore();

  return (
    <Toast data-component-id="src/components/ui/GlobalToast.tsx:11:4" data-component-path="src/components/ui/GlobalToast.tsx" data-component-line="11" data-component-file="GlobalToast.tsx" data-component-name="Toast" data-component-content="%7B%22elementName%22%3A%22Toast%22%7D"
      message={toast.message}
      isVisible={toast.isVisible}
      onClose={hideToast}
      duration={toast.duration}
      type={toast.type}
    />
  );
};

export default GlobalToast;
